import Marquee from "react-fast-marquee";

export default function EditorialMarquee({
    items = [
        "Iconic addresses",
        "Hand-cast concrete",
        "Regional stone",
        "37 residences, ever",
        "Six cities",
        "Curated lifestyles",
    ],
}) {
    return (
        <section
            data-testid="editorial-marquee"
            className="relative border-y border-white/10 bg-forest-950 py-8 md:py-10"
        >
            <Marquee gradient={false} speed={38} pauseOnHover={false}>
                {items.map((t, i) => (
                    <span
                        key={i}
                        className="flex items-center gap-8 md:gap-12 mx-8 md:mx-12"
                    >
                        <span className="font-serif-display italic text-[2.4rem] md:text-[3.75rem] leading-none text-ivory/95">
                            {t}
                        </span>
                        <span className="h-2 w-2 bg-lime shrink-0" />
                    </span>
                ))}
            </Marquee>
        </section>
    );
}
